export interface MyEatzyWidgetConfig {
  widgets: {
    usuals: boolean;
    kudoz: boolean;
    friends: boolean;
    nearby: boolean;
    deals: boolean;
    stats: boolean;
  };
  homeTab: string;
}

export const DEFAULT_WIDGET_CONFIG: MyEatzyWidgetConfig = {
  widgets: {
    usuals: true,
    kudoz: false,
    friends: false,
    nearby: false,
    deals: true,
    stats: false,
  },
  homeTab: 'feed',
};

export interface NearbyRestaurant {
  id: string | number;
  name: string;
  logo?: string | null;
  address?: string | null;
  city?: string | null;
  averageRating?: number | string | null;
}

export interface FeedReview {
  id: string | number;
  text?: string | null;
  overallRating?: number | null;
  likesCount?: number | null;
  author?: {
    name?: string | null;
    displayName?: string | null;
    avatar?: string | null;
  } | null;
  restaurant?: {
    name?: string | null;
  } | null;
}

export interface UserBadge {
  id: string | number;
  name: string;
  earnedAt?: string | null;
}

export interface KudozPromotion {
  id: string | number;
  title?: string | null;
  name?: string | null;
  description?: string | null;
  kudozMultiplier?: number | null;
  expiresAt?: string | null;
  endDate?: string | null;
}

export interface UserCoupon {
  id: string | number;
  description?: string | null;
  name?: string | null;
  code?: string | null;
  discountType?: 'percent' | 'fixed' | string | null;
  discountValue?: number | null;
  expiresAt?: string | null;
  validUntil?: string | null;
  restaurantName?: string | null;
}

export interface UserStats {
  reviewsCount?: number | null;
  followersCount?: number | null;
  followingCount?: number | null;
}

export interface MyReview {
  id: string | number;
  text?: string | null;
  likesCount?: number | null;
  restaurant?: {
    name?: string | null;
  } | null;
}
